export default "__VITE_ASSET__c527bb6f__"